export default {
  getFormInfo(formInfo, id) {
    const haveTarget = formInfo.find((d) => d.formparam === id);
    if (haveTarget) {
      return haveTarget.formvalue;
    }
    return haveTarget;
  }
};
